import Vue from "vue";
import axios from "axios";
import store from "@/store";

Vue.prototype.$http = axios;

if (typeof Storage !== "undefined") {
  // this.$http.defaults.headers.common["season_id"] = 7;
  
  let UserToken = localStorage.getItem("token");
  let bid = localStorage.getItem("bid");
  let seasonId = localStorage.getItem("seasonId");
  let root = localStorage.getItem("root");
  
  let lang = localStorage.getItem("lang") ? localStorage.getItem("lang") : "ru";
  
  store.dispatch("setLanguageCurrent", lang);

  Vue.prototype.$http.defaults.headers.common["X-CSRF-TOKEN"] =
    "7pTpIc1LnucNjLWGaJHKlQK2eqb9SAq54R04zVlM";
  Vue.prototype.$http.defaults.headers.common["X-Requested-With"] =
    "XMLHttpRequest";

  if (UserToken) {
    Vue.prototype.$http.defaults.headers.common["Authorization"] = UserToken;
  }

  if (bid) {
    Vue.prototype.$http.defaults.headers.common["bid"] = bid;
  }
  if (seasonId) {
    Vue.prototype.$http.defaults.headers.common["season-id"] = seasonId;
  }

  // Vue.prototype.$http.defaults.headers.common["season-id"] = 7;

  if (root) {
    Vue.prototype.$http.defaults.headers.common["root"] = root;
  }

  if (lang) {
    Vue.prototype.$http.defaults.headers.common["localization"] = lang;
  }
}

Vue.prototype.$http.defaults.baseURL = process.env.HOST_SERVER; 

Vue.prototype.$http.interceptors.request.use(
  (config) => {
    return config;
  },
  (error) => {
    return Promise.reject(error);
  }
);

Vue.prototype.$http.interceptors.response.use(
  (response) => {
    return response;
  },
  (error) => {
    if (error.response.status == "401") {
    }
    if (error.response.status == "422") {
    }
    if (error.response.status == "500") {
    }
    if (error.response.status == "429") {
    }
    return Promise.reject(error);
  }
);

export default Vue.prototype.$http;
